import { Component, OnInit, OnDestroy,Injectable } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {ShareService} from './../services/services';
import 'rxjs/add/operator/publishReplay';

let headers = new Headers();
headers.append('Access-Control-Allow-Origin', '*');
headers.append('Content-Type', 'application/x-www-form-urlencoded');
let options = new RequestOptions({ headers: headers });	 

export class Welcome {
    constructor(public slug: string, public description: string,public title: string) { }
}

@Injectable()
export class WelcomeService {

  
    public _welcome;
    constructor(
      private http: Http,
      
      private shareService: ShareService) {
  
  
    }

	getPage(slug:string) {
	   let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');	    ///alert(this.getToken());
	    
	    let options = new RequestOptions({ headers:headers });
	   	let apirul=this.shareService.getApiUrl()+'/welcome';
	   	if (!this._welcome) {  	     
        this._welcome = this.http.get(apirul,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);  

        }
        return this._welcome

	}
	
	handleError(error) {
        console.error("Got the error: " + JSON.stringify(error));
        return Observable.throw(error.json().error || 'Welcome  Server error');
    }
}


// WEBPACK FOOTER //
// ./resources/assets/typescript/welcome/welcome.service.ts